<div
  *ngIf="message"
  class="relative rounded-[12px] h-fit sm:w-[478px] w-[286px] sm:mx-0 mx-auto p-4 bg-green-50 border-[2px] border-green-200 text-white flex items-center justify-between"
  [class.bg-gray-50]="type == 'info'"
  [class.border-gray-200]="type == 'info'"
  [class.bg-green-50]="type == 'success'"
  [class.border-green-200]="type == 'success'"
  [class.bg-orange-50]="type == 'warning'"
  [class.border-orange-200]="type == 'warning'"
  [class.bg-red-50]="type == 'danger'"
  [class.border-red-200]="type == 'danger'"
  [class.bg-blue-50]="type == 'neutral'"
  [class.border-blue-200]="type == 'neutral'"
  style="box-shadow: 0px 3px 8px 4px rgba(24, 26, 28, 0.2)">
  <section class="flex items-center">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="type === 'success'">
      <g filter="url(#filter0_d_3127_16453)">
        <circle cx="20" cy="20" r="16" fill="#33C27D" />
        <g clip-path="url(#clip0_3127_16453)">
          <path
            d="M16.625 20L18.875 22.25L23.375 17.75M27.5 20C27.5 24.1421 24.1421 27.5 20 27.5C15.8579 27.5 12.5 24.1421 12.5 20C12.5 15.8579 15.8579 12.5 20 12.5C24.1421 12.5 27.5 15.8579 27.5 20Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3127_16453"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3127_16453" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3127_16453" result="shape" />
        </filter>
        <clipPath id="clip0_3127_16453">
          <rect width="18" height="18" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>

    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="type === 'danger'">
      <g filter="url(#filter0_d_8111_46965)">
        <circle cx="20" cy="20" r="16" fill="#D90C34" />
        <g clip-path="url(#clip0_8111_46965)">
          <path
            d="M22.25 17.75L17.75 22.25M17.75 17.75L22.25 22.25M27.5 20C27.5 24.1421 24.1421 27.5 20 27.5C15.8579 27.5 12.5 24.1421 12.5 20C12.5 15.8579 15.8579 12.5 20 12.5C24.1421 12.5 27.5 15.8579 27.5 20Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_8111_46965"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8111_46965" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8111_46965" result="shape" />
        </filter>
        <clipPath id="clip0_8111_46965">
          <rect width="18" height="18" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="type === 'warning'">
      <g filter="url(#filter0_d_3127_16581)">
        <circle cx="20" cy="20" r="16" fill="#F06800" />
        <g clip-path="url(#clip0_3127_16581)">
          <path
            d="M20 27.5C24.1421 27.5 27.5 24.1421 27.5 20C27.5 15.8579 24.1421 12.5 20 12.5C15.8579 12.5 12.5 15.8579 12.5 20C12.5 24.1421 15.8579 27.5 20 27.5Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M17 18.2C17 17.78 17 17.5699 17.0817 17.4095C17.1537 17.2684 17.2684 17.1537 17.4095 17.0817C17.5699 17 17.78 17 18.2 17H21.8C22.22 17 22.4301 17 22.5905 17.0817C22.7316 17.1537 22.8463 17.2684 22.9183 17.4095C23 17.5699 23 17.78 23 18.2V21.8C23 22.22 23 22.4301 22.9183 22.5905C22.8463 22.7316 22.7316 22.8463 22.5905 22.9183C22.4301 23 22.22 23 21.8 23H18.2C17.78 23 17.5699 23 17.4095 22.9183C17.2684 22.8463 17.1537 22.7316 17.0817 22.5905C17 22.4301 17 22.22 17 21.8V18.2Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3127_16581"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3127_16581" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3127_16581" result="shape" />
        </filter>
        <clipPath id="clip0_3127_16581">
          <rect width="18" height="18" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>

    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="type === 'info'">
      <g filter="url(#filter0_d_8111_27712)">
        <circle cx="20" cy="20" r="16" fill="#4A5052" />
        <path
          d="M19.9998 16.7492V19.7492M19.9998 22.7492H20.0073M18.9613 12.918L12.7926 23.573C12.4505 24.1639 12.2794 24.4594 12.3047 24.702C12.3267 24.9135 12.4376 25.1057 12.6096 25.2308C12.8068 25.3742 13.1483 25.3742 13.8312 25.3742H26.1685C26.8514 25.3742 27.1928 25.3742 27.39 25.2308C27.5621 25.1057 27.6729 24.9135 27.6949 24.702C27.7202 24.4594 27.5491 24.1639 27.207 23.573L21.0383 12.918C20.6974 12.3291 20.5269 12.0347 20.3045 11.9358C20.1105 11.8495 19.8891 11.8495 19.6951 11.9358C19.4727 12.0347 19.3022 12.3291 18.9613 12.918Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <filter
          id="filter0_d_8111_27712"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8111_27712" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8111_27712" result="shape" />
        </filter>
      </defs>
    </svg>

    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="type === 'neutral'">
      <g filter="url(#filter0_d_8111_27023)">
        <circle cx="20" cy="20" r="16" fill="#1F62E7" />
        <g clip-path="url(#clip0_8111_27023)">
          <path
            d="M20 17V20M20 23H20.0075M27.5 20C27.5 24.1421 24.1421 27.5 20 27.5C15.8579 27.5 12.5 24.1421 12.5 20C12.5 15.8579 15.8579 12.5 20 12.5C24.1421 12.5 27.5 15.8579 27.5 20Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_8111_27023"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8111_27023" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8111_27023" result="shape" />
        </filter>
        <clipPath id="clip0_8111_27023">
          <rect width="18" height="18" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>

    <span class="ml-3 text-base text-gray-700 leading-5 font-medium font-radikal-medium">
      {{ message }} <br /> <span *ngIf="link" (click)="navigateToFilter()" class="checkHere">Check Here</span>
      <span class="underline cursor-pointer" (click)="actions.onClick()" *ngIf="actions">
        {{ actions.action }}
      </span>
    </span>
  </section>
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [id]="'onboarding-alert-btn-11234154312894'"
    (click)="hideNote()"
    class="cursor-pointer">
    <path d="M12 4L4 12M4 4L12 12" stroke="#2A2C2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</div>
